import round from './round';

function polarToCartesian(x, y, radius, angle) {
  const radians = (angle - 90) * Math.PI / 180;
  return [
    round(x + radius * Math.cos(radians), 5),
    round(y + radius * Math.sin(radians), 5),
  ];
}

export default function ({
  startAngle,
  endAngle,
  x = 0,
  y = 0,
  radius = 0.5,
}) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;
  return [
    'M', ...start,
    'A', radius, radius, 0, largeArcFlag, 0, ...end,
  ].join(' ');
}
